import { Modal } from '@web/components/Modal'
import SolutionsIntroAccordion from '@web/components/SolutionsIntroAccordion'

export const SolutionsModal = ({
  modalOpen,
  setModalOpen,
}: {
  modalOpen: boolean
  setModalOpen: (open: boolean) => void
}) => {
  return (
    <Modal
      open={modalOpen}
      onOpenChange={setModalOpen}
      className="sm:p-12 sm:px-20 pb-12 sm:pb-16"
      title="I manage risk through..."
      hideTitle
    >
      <SolutionsIntroAccordion />
    </Modal>
  )
}
